import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";
import { Row, Col, Button } from 'react-bootstrap';
import "./Login.css";
import { loginService } from "../../services/loginService";
const JWTLogin = ({ login }) => {
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // clear previous errors
    setError('');
    setPasswordError('');

    // if (!username || !password) {
    //   setError('Both username and password are required');
    //   return;
    // }
    // Trim spaces before validation or API call
    const trimmedUsername = username.trim();
    const trimmedPassword = password.trim();

    if (!trimmedUsername || !trimmedPassword) {
      setError('Both username and password are required');
      return;
    }
    try {
      //const data = await loginService({ userName: username, password });
      const data = await loginService({ userName: trimmedUsername, password: trimmedPassword });

      if (data.message && typeof data.message === 'string' && data.message.toLowerCase().includes('invalid')) {
        setPasswordError('Incorrect password');
        return;
      }

      // Only proceed when we actually have user info / token
      if (data && (data.username || data.token || data.accessToken)) {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('username', data.username);
        localStorage.setItem('employeeId', data.employeeId);
        localStorage.setItem('role', data.role);
        localStorage.setItem('email', data.email);
        localStorage.setItem('full_name', data.full_name);
        localStorage.setItem("roleId", data.roleId);
        localStorage.setItem("mobile", data.mobile);
        localStorage.setItem("token", data.token);
        localStorage.setItem("employeeUniqueIdLogin", data.employeeUniqueId);
        localStorage.setItem("districtName", data.districtName);
        localStorage.setItem("districtId", data.districtId);
        localStorage.setItem("zoneName",data.zoneName);
        localStorage.setItem("zoneId",data.zoneId);
        localStorage.setItem("stateName",data.stateName);
        localStorage.setItem("stateId",data.stateId);
       localStorage.setItem('gd', JSON.stringify(data.godowns));


        login();
        // alert("Login Successful");
        navigate('/dashboard');
      } else {
        setError('Login failed: Missing token or invalid credentials.');
      }
    } catch (err) {
      const serverMessage = err?.response?.data?.message;

      if (serverMessage && typeof serverMessage === 'string' && serverMessage.toLowerCase().includes('invalid')) {
        setPasswordError('Incorrect password');
        return;
      }

      if (err?.response?.status === 401) {
        setPasswordError('Incorrect password');
        return;
      }

      setError('Invalid username or password. Please try again.');
    }
  };

  return (
    <div className="login-main">
      <div className="login-form">
        <h3>Login</h3>
        <form onSubmit={handleSubmit} noValidate>
          <div className="login-box">
            <label htmlFor="userName">Username</label>
            <input
              type="text"
              id="userName"
              placeholder="Username"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
              required
            />
          </div>

          <div className="password-box">
            <label htmlFor="password">Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setPasswordError(''); }}
              required
              aria-invalid={passwordError ? 'true' : 'false'}
              aria-describedby={passwordError ? 'password-error' : undefined}
            />
            <span
              className="eye-icon-login"
              onClick={() => {
                if (!document.getElementById('password').disabled) {
                  setShowPassword(!showPassword);
                }
              }}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>

          </div>
          {passwordError && (
            <div id="password-error" className="field-error">
              {passwordError}
            </div>
          )}
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="checkbox-section">
            {/* optional UI */}
          </div>

          <Row>
            <Col>
              <Button className="login-btn" type="submit">
                Login
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    </div>
  );
};

export default JWTLogin;
